import { sendAFEvent, setAFCustomerId } from './appsflyer';
import { sendAmplitudeData, setAmplitudeUserId } from './amplitude';
import { sendLockerStudioData } from './lockerStudio';
import BI_EVENTS from './biEvents';
import { fetchWrapper } from '../utils';
import ReactGA from 'react-ga4';
import RedditPixel from 'react-reddit-pixel';
import sendVwoEvent from './vwo';
import { REACT_APP_GOOGLE_TRACKING_ID, REACT_APP_GOOGLE_ADS_ID } from './GA';

const isStage = process.env.REACT_APP_ENV === 'stage';
const REACT_APP_RUNWAYER_URL = process.env.REACT_APP_RUNWAYER_URL;

export const sendAnalyticsEvents = (eventName, eventParams = {}) => {
    const biEventName = BI_EVENTS[eventName];

    sendAFEvent(eventName, eventParams);
    sendAmplitudeData(eventName, eventParams);
    sendLockerStudioData(biEventName || eventName, eventParams);
    pushGoogleTag(eventName, eventParams);
};

export const sendPurchaseEvent = (price, currency, plan, productId, subId, eventId, eventsData) => {
    pushFBEvent(
      {
          currency: currency || "USD",
          itemCount: 1,
          transactionId: subId,
          price: price,
          value: price,
      },
      eventId,
    );

    RedditPixel.track("Purchase", {
        currency: currency || "USD",
        itemCount: 1,
        transactionId: subId,
        price: price,
        event_id: eventId,
    });

    sendVwoEvent(price, productId);

    if (!isStage) {
        ReactGA.event("purchase", {
            currency: currency || "USD",
            value: price,
            transaction_id: subId,
            gclid: eventsData?.gclid ?? '',
            items: {
                item_id: plan,
                item_name: plan,
            },

            send_to: REACT_APP_GOOGLE_TRACKING_ID,
        });
        ReactGA.event("conversion", {
            send_to: REACT_APP_GOOGLE_ADS_ID,
            value: price,
            currency: currency || "USD",
            transaction_id: subId,
        });
    }
    window?.ttq?.track('CompletePayment', {
        value: price,
        currency: currency || 'USD',
        contents: [
            {
                content_type: plan,
                content_name: plan,
            },
        ],
        event_id: eventId,
    });
    window?.pintrk?.('track', 'checkout', {
        value: price,
        order_quantity: 1,
        currency: currency || 'USD',
        event_id: eventId,
        line_items: [
            {
                product_name: plan,
                product_id: plan,
                product_price: price,
                product_quantity: 1,
            },
        ],
    });
};

export const setAnalyticsUserId = (userId = '') => {
    setAmplitudeUserId(userId);
    setAFCustomerId(userId);
};

export const pushGoogleTag = (eventName, eventParams, tagId = REACT_APP_GOOGLE_TRACKING_ID) => {
    if (isStage) return;
    ReactGA.event(eventName, { ...eventParams, send_to: tagId });
};

export const pushFBEvent = (data, eventId) => {
    if (window.fbq) {
        window.fbq('track', 'Purchase'+(isStage ? '_test' : ''), data, {eventID: eventId});
    }
};

export const sendRunwayerConversion = (body) => {
    fetchWrapper(REACT_APP_RUNWAYER_URL, {body})
      .then((data) => console.log(data))
      .catch((err) => console.log(err))
};
